"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNoopAuthFacade = exports.createAuthFacade = void 0;
var axios_1 = __importDefault(require("axios"));
var userService_1 = __importDefault(require("./userService"));
var windowNavigator_1 = __importDefault(require("./windowNavigator"));
var authApi_1 = require("./authApi");
var authService_1 = require("./authService");
var sessionService_1 = require("./sessionService");
var NoOpUserService = /** @class */ (function () {
    function NoOpUserService() {
        this.getUser = function () { return Promise.resolve(null); };
    }
    return NoOpUserService;
}());
var createAuthFacade = function () {
    var httpAxios = axios_1.default.create();
    var jwtStorage = new sessionService_1.LocalStorageSession(window.localStorage);
    var userService = new userService_1.default(jwtStorage, new windowNavigator_1.default(), new authApi_1.AuthApi(jwtStorage, httpAxios));
    (0, authService_1.authenticateAxios)(httpAxios, jwtStorage);
    var authenticate = function (axiosInstance) {
        (0, authService_1.authenticateAxios)(axiosInstance, jwtStorage);
    };
    return {
        authenticate: authenticate,
        userService: userService,
    };
};
exports.createAuthFacade = createAuthFacade;
var createNoopAuthFacade = function () {
    var userService = new NoOpUserService();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
    var noOpAuthenticate = function (axiosInstance) { };
    return {
        authenticate: noOpAuthenticate,
        userService: userService,
    };
};
exports.createNoopAuthFacade = createNoopAuthFacade;
//# sourceMappingURL=authFacade.js.map